



























































import { DataFindByPurchaseBuyerState } from "@/store/purchaseRequest/modulePurchaseBuyer";
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import DetailTablePurchaseRequest from "../DetailTablePurchaseRequest.vue";
import GroupButtons from './../buttonsPurchaseRequest/GroupButtons.vue'
export default Vue.extend({
  components: {
    DetailTablePurchaseRequest,
    GroupButtons
  },
  data() {
    return {
      page: 1,
      dataStateStep: {
        userId: this.getCurrentUserLoggedIn().id,
        state: "pendiente",
        step: "budgetManager",
      } as DataFindByPurchaseBuyerState,    
      headers:[
        {
          text:'Id Solicitud',
          sorteable:false,
          value:'purchase_request_id'
        },
        {
          text:'Id Registro de Compra',
          sorteable:false,
          value:'id'
        },
        {
          text:'N° Licitación',
          sorteable:false,
          value:'n_licitation'
        },
        {
          text:'N° Orden',
          sorteable:false,
          value:'n_order'
        },
        {
          text:'Observación',
          sorteable:false,
          value:'observation'
        },
        {
          text:'Comprador',
          sorteable:false,
          value:'user'
        },
        {
          text:'Acciones',
          sorteable:false,
          value:'actions'
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      getPending: "purchaseBuyer/getPurchaseBuyerPending",
      getLoading: "purchaseBuyer/getLoading",
    }),
  },
  methods: {
    ...mapActions({
      setPending: "purchaseBuyer/getPurchaseBuyerPending",
    }),
    changePage() {
      this.$store.commit("purchaseBuyer/setPagePurchaseBuyerPending", this.page);
      this.setPending({ ...this.dataStateStep });
    },
  },
  mounted() {
    this.changePage();
  },
});
